import util from '../util'

let controller = 'Carteiras'
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall', 'post', 'put', 'persist']), {
  GetByNumero: function (dto) {
    return util.Axios.Get(controller + '/GetByNumero', dto)
  }
})
